import React, { useMemo, useState } from "react";
import Tabs from "../../../elements/Tabs";
import ScholarshipTabContent from "./ScholarshipTabContent";
import ScholarshipImage from "./ScholarshipImage";
import useFetch from "../../../../hooks/useFetch";
import { pageList } from "../../../../services/pageService";

const ScholarshipSection = () => {
  const [selected, setSelected] = useState(undefined);

  const { data, error, isLoading, updateData, isFetching, refetch } = useFetch({
    dependencies: ["font-page"],
    fetchFunction: async () => {
      const res = await pageList({});
      setSelected(res?.docs?.data[0]?._id);
      return res?.docs;
    },
  });

  // Inside your component
  const tabs = useMemo(() => {
    return (data?.data || []).map((item, i) => ({
      _id: item?._id,
      name: item?.title,
      component: <ScholarshipTabContent data={item} />,
    }));
  }, [JSON.stringify(data?.data)]);

  return (
    <>
      <section className="relative flex w-full pb-12 pt-0 xls:py-24 bg-white">
        <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
          <div className="space-y-10 sm:space-y-16">
            <h2 className="text-3xl sm:text-4xl xls:text-[42px] font-bold text-center">
              Overview
            </h2>
            <div className="relative grid lg:grid-cols-2 gap-10">
              <div className="relative">
                <ScholarshipImage
                  data={(data?.data || [])?.find(
                    (item) => item?._id === selected
                  )}
                />
              </div>
              <div className="relative lg:pt-16">
                <Tabs
                  tabs={tabs}
                  tabNavClass={
                    "border border-chestnut-rose rounded-full mx-auto lg:mx-0 overflow-auto gap-[20px] sm:gap-[0px]"
                  }
                  setSelected={setSelected}
                  tabButtonClass={
                    "!rounded-full !bg-transparent !text-xs md:!text-base !px-2 sm:!px-4 xls:!px-10 !text-chestnut-rose !h-12 xls:!h-14"
                  }
                  tabButtonActiveClass={"!bg-chestnut-rose !text-white"}
                  tabContentClass={"!py-10"}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ScholarshipSection;
